import { ScriptStep } from '@/constants'

export const formatStepKey = (
  step: ScriptStep,
  witnessIndex?: number | string,
): string => (witnessIndex === undefined ? step : `${step}-${witnessIndex}`)

export const parseStepKey = (
  key: string,
): { step: ScriptStep; witnessIndex: string | undefined } => {
  const [step, witnessIndex] = key.split('-')
  return { step: step as ScriptStep, witnessIndex }
}

const singleWitnessEventScopedSteps = new Set<ScriptStep>([
  ScriptStep.ATTENDANCE,
  ScriptStep.OPENING,
  ScriptStep.QUESTIONING,
  ScriptStep.CLOSING,
  ScriptStep.REVIEW,
])

export const getCurrentEventIndex = (
  currentStepKey: string,
  eventCount: number,
): number | undefined => {
  const { step: currentStep, witnessIndex } = parseStepKey(currentStepKey)

  if (witnessIndex !== undefined) {
    const parsedCurrentEventIndex = Number(witnessIndex)
    return Number.isNaN(parsedCurrentEventIndex)
      ? undefined
      : parsedCurrentEventIndex
  }

  if (eventCount === 1 && singleWitnessEventScopedSteps.has(currentStep)) {
    return 0
  }

  return undefined
}

export const getBaseStepKey = (
  key: ScriptStep | string | null | undefined,
): ScriptStep | null => (key ? parseStepKey(key).step : null)
